export default "__VITE_ASSET__DlOvtvdZ__"